import React, { useEffect, useState } from 'react'
import { Dropdown } from 'react-bootstrap'
import { useTranslation } from 'react-i18next'
import { toastService } from '../../services/toast.service'
import { Toast as ToastType } from '../../types'

export const NotificationsDropdown: React.FC = () => {
  const { t } = useTranslation()
  const [toasts, setToasts] = useState<ToastType[]>([])

  useEffect(() => {
    const unsubscribe = toastService.subscribeToToasts((newToasts) => {
      setToasts(newToasts)
    })

    return unsubscribe
  }, [])

  const handleOpenChange = (open: boolean) => {
    toastService.suppressPopupToasts = open
  }

  const handleClearAll = () => {
    toastService.clearToasts()
  }

  return (
    <Dropdown as="li" className="nav-item notifications-dropdown" onToggle={handleOpenChange}>
      {toasts.length > 0 && <span className="badge rounded-pill z-3 pe-none bg-secondary me-2 position-absolute top-0 left-0">{toasts.length}</span>}
      <Dropdown.Toggle as="button" className="btn border-0 d-flex align-items-center" id="notificationsDropdown">
        <i className="bi bi-bell" style={{ fontSize: '1.3em' }}></i>
      </Dropdown.Toggle>

      <Dropdown.Menu
        align="end"
        className="notifications-popup shadow-lg border-0"
        style={{
          width: '400px',
          maxWidth: '90vw',
          marginTop: '0.5rem',
          borderRadius: '0.75rem',
          backgroundColor: 'var(--bs-body-bg)',
          border: '1px solid var(--bs-border-color)',
          boxShadow: '0 0.5rem 1rem rgba(0, 0, 0, 0.15)',
        }}
      >
        <div className="notifications-header p-3 border-bottom bg-light" style={{ borderRadius: '0.75rem 0.75rem 0 0' }}>
          <div className="d-flex align-items-center justify-content-between">
            <h6 className="mb-0 fw-semibold text-primary">
              <i className="bi bi-bell me-2"></i>
              {t('notifications')}
            </h6>
            {toasts.length > 0 && (
              <button className="btn btn-sm btn-outline-secondary" onClick={handleClearAll} title={t('clear_all')}>
                <i className="bi bi-trash"></i>
              </button>
            )}
          </div>
        </div>

        <div className="notifications-content">
          {toasts.length === 0 ? (
            <div className="text-center p-4">
              <i className="bi bi-bell-slash text-muted" style={{ fontSize: '2rem' }}></i>
              <p className="text-muted mt-2 mb-0">
                <em>{t('no_notifications')}</em>
              </p>
            </div>
          ) : (
            <div className="notifications-list" style={{ maxHeight: '400px', overflowY: 'auto' }}>
              {toasts.map((toast, index) => (
                <div
                  key={toast.id}
                  className="notification-item"
                  style={{
                    borderBottom: index < toasts.length - 1 ? '1px solid var(--bs-border-color)' : 'none',
                    transition: 'background-color 0.2s ease',
                  }}
                >
                  <div className="toast-notification">
                    <div className="d-flex align-items-start">
                      {!toast.error && <i className="bi bi-info-circle text-primary me-2 mt-1"></i>}
                      {toast.error && <i className="bi bi-exclamation-triangle text-warning me-2 mt-1"></i>}
                      <div className="flex-grow-1">
                        <p className="mb-1">{toast.content}</p>
                        {toast.error && (
                          <details className="small">
                            <summary className="text-muted">Detalji greške</summary>
                            <div className="mt-2 small text-muted">{typeof toast.error === 'object' ? JSON.stringify(toast.error) : toast.error}</div>
                          </details>
                        )}
                        {toast.action && toast.actionName && (
                          <button
                            type="button"
                            className="btn btn-sm btn-outline-primary mt-2"
                            onClick={() => {
                              if (toast.action) {
                                toast.action()
                              }
                              const newToasts = toasts.filter((t) => t.id !== toast.id)
                              setToasts(newToasts)
                              toastService.closeToast(toast)
                            }}
                          >
                            {toast.actionName}
                          </button>
                        )}
                      </div>
                      <button
                        type="button"
                        className="btn btn-sm btn-outline-secondary ms-2"
                        aria-label="Close"
                        onClick={() => {
                          const newToasts = toasts.filter((t) => t.id !== toast.id)
                          setToasts(newToasts)
                        }}
                      >
                        <i className="bi bi-x"></i>
                      </button>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      </Dropdown.Menu>
    </Dropdown>
  )
}
